import { render } from "./Games.vue?vue&type=template&id=20b38b3a&scoped=true"
import script from "./Games.vue?vue&type=script&lang=js"
export * from "./Games.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-20b38b3a"

export default script